// CoverLink uses OldMutualMalawi's full PoliciesProcessing, which already
// handles CoverLink-specific logic: the stage info card (getStageInfo /
// STAGE_DESCRIPTIONS), the isCoverLink MakerChecks wiring (allowRequestChanges,
// sentBackForChanges), the Escalate action, and getCustomerQuotes. No divergence
// is needed yet — point here if CoverLink-only behaviour is required later.
export { default } from '../../OldMutualMalawi/PoliciesProcessing'
